import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: `"Graphik-Regular"`,
  },
  palette: {
    common: {
      white: "#ffffff",
    },
  }
});

export default theme;
